/**
 * Fallacy Filtering Logic
 * Pure functions for filtering fallacy data
 */

import type { FallacyDefinition } from '@/constants/fallacyDefinitions';

export interface FallacyFilterCriteria {
  searchTerm: string;
  category: string;
  severity: string;
}

/**
 * Filter fallacies based on search criteria
 */
export const filterFallacies = (
  fallacies: [string, FallacyDefinition][],
  criteria: FallacyFilterCriteria
): [string, FallacyDefinition][] => {
  return fallacies.filter(([name, fallacy]) => {
    const matchesSearch = matchesSearchTerm(name, fallacy, criteria.searchTerm);
    const matchesCategory = criteria.category === "all" || fallacy.category === criteria.category;
    const matchesSeverity = criteria.severity === "all" || fallacy.severity === criteria.severity;
    
    return matchesSearch && matchesCategory && matchesSeverity;
  });
};

/**
 * Check if fallacy matches search term
 */
const matchesSearchTerm = (name: string, fallacy: FallacyDefinition, searchTerm: string): boolean => {
  if (!searchTerm) return true;
  
  const lowerSearch = searchTerm.toLowerCase();
  
  return (
    name.toLowerCase().includes(lowerSearch) ||
    fallacy.description.toLowerCase().includes(lowerSearch) ||
    fallacy.alternativeNames.some(alt => alt.toLowerCase().includes(lowerSearch))
  );
};
